import { Button, styled } from '@mui/material';
import { HelixPalette } from '../../../helix';
/**
 * Button implementation specifically for product item in product switcher menu
 */
export const ProductButton = styled('button')({
    display: 'flex',
    height: 56,
    width: 276,
    alignItems: 'center',
    paddingLeft: 8,
    borderRadius: 8,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: HelixPalette.teal80,
    },
    '&:active:focus': {
        backgroundColor: HelixPalette.teal100,
    },
    '&:focus-visible': {
        borderRadius: '8px',
        outline: `2px solid ${HelixPalette.blue70}`,
        offset: '2px',
    },
    gap: '8px',
});
/**
 * Button for current product switcher visible on horizontal homebar
 */
export const SwitcherButton = styled(Button)({
    position: 'relative',
    minHeight: '64px',
    paddingLeft: '16px',
    margin: 0,
    left: 0,
    top: 0,
    backgroundColor: HelixPalette.teal90,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'none',
    borderRadius: '0px',
    '&:hover': {
        backgroundColor: HelixPalette.teal80,
    },
    '&:active:focus': {
        backgroundColor: HelixPalette.teal100,
    },
    '&:focus-visible': {
        outline: `2px solid ${HelixPalette.blue70}`,
        outlineOffset: '-8px',
    },
});
